import getQueriesOnUrl from './getQueriesOnUrl'

const regex = [/utm_/]
const itemStorage = 'utm_queries'

export default {
  get: () => getQueriesOnUrl.get(regex, itemStorage),
  set: () => getQueriesOnUrl.set(regex, itemStorage)
}
